<ngx-spinner [name]="spinnerName" [fullScreen]="false" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff"
    type="ball-circus" />

<!-- Show full editor only for admins; non-admins see minimal auto-processing view -->
<ng-container *ngIf="authService.isAdmin(); else nonAdminAutoProcessing">
    <div class="super-main d-flex justify-content-center align-items-center">
        <div class="main-container">
            <div class="row main mx-3">
                <div class="col">
                    <div class="card mt-3">
                        <div *ngIf="authService.isAdmin()"
                            class="card-header d-flex justify-content-between align-items-center">
                            <h6> KI - Modelle </h6>
                            <button class="btn btn-sm" (click)="slideInBody()"><i
                                    class="bi bi-arrow-down-up"></i></button>
                        </div>
                        <div *ngIf="slideIn" class="card-body">
                            <form class="form-sm">

                                <div class="input-group mb-3">
                                    <span class="input-group-text">Embedding Model</span>
                                    <select id="embedding_model" class="form-select form-select-sm"
                                        [(ngModel)]="embeddingModel" [ngModelOptions]="{standalone: true}">
                                        <optgroup label="Voyage">
                                            <option value="voyage-law-2">Voyage Law 2</option>
                                        </optgroup>
                                        <optgroup label="OpenAI">
                                            <option value="text-embedding-3-large">text-embedding-3-large</option>
                                            <option value="text-embedding-3-small">text-embedding-3-small</option>
                                            <option value="text-embedding-ada-002">text-embedding-ada-002</option>
                                        </optgroup>
                                        <optgroup label="Google">
                                            <option value="gemini-embedding-exp-03-07">Gemini Embedding (Experimental)
                                            </option>
                                            <option value="text-embedding-004">text-embedding-004</option>
                                            <option value="text-embedding-001">text-embedding-001</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="input-group mb-3">
                                    <span class="input-group-text">LLM</span>
                                    <select id="model" class="form-select form-select-sm" [(ngModel)]="model"
                                        [ngModelOptions]="{standalone: true}">
                                        <optgroup label="Anthropic">
                                            <option value="claude-3-7-sonnet">Claude 3.7 Sonnet</option>
                                            <option value="claude-3-5-haiku">Claude 3.5 Haiku</option>
                                            <option value="claude-3-5-sonnet">Claude 3.5 Sonnet</option>
                                            <option value="claude-3-opus">Claude 3 Opus</option>
                                        </optgroup>
                                        <optgroup label="OpenAI">
                                            <option value="gpt-5.2">GPT-5.2</option>
                                            <option value="gpt-5">GPT-5</option>
                                            <option value="gpt-5-mini">GPT-5 Mini</option>
                                            <option value="gpt-5-nano">GPT-5 Nano</option>
                                            <option value="gpt-4.5">GPT-4.5</option>
                                            <option value="gpt-4o">GPT-4o</option>
                                            <option value="gpt-4o-mini">GPT-4o-mini</option>
                                        </optgroup>
                                        <optgroup label="Google">
                                            <option value="gemini-2.5-pro">Gemini 2.5 Pro (Preview)</option>
                                            <option value="gemini-2.5-flash-preview-04-17">Gemini 2.5 Flash Preview
                                            </option>
                                            <option value="gemini-2.0-flash">Gemini 2.0 Flash</option>
                                            <option value="gemini-2.0-flash-lite">Gemini 2.0 Flash‑Lite</option>
                                            <option value="gemini-2.0-flash-live-001">Gemini 2.0 Flash Live</option>
                                            <option value="gemini-1.5-pro">Gemini 1.5 Pro</option>
                                            <option value="gemini-1.5-flash">Gemini 1.5 Flash</option>
                                            <option value="gemini-1.5-flash-8b">Gemini 1.5 Flash‑8B</option>
                                        </optgroup>
                                    </select>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="card mt-3">
                        <div class="card-header d-flex justify-content-between align-items-center">

                            <button class="btn btn-success btn-sm" (click)="processedMstrlsngShow()">Fall
                                Bearbeiten</button>
                            <button class="btn btn-warning btn-sm" (click)="processedMstrlsngShow()">Processed
                                Musterloesung</button>

                        </div>
                        <div *ngIf="!processedMstrlsng" class="card-body ">
                            <form class="form-sm">

                                <div class="input-group mb-3">
                                    <span class="input-group-text" id="basic-addon1">Name</span>
                                    <input type="text" class="form-control" [(ngModel)]="name" placeholder="Name"
                                        aria-label="Name" [ngModelOptions]="{standalone: true}">
                                </div>


                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Beschreibung</span>
                                    <textarea class="form-control" [(ngModel)]="description" placeholder="Beschreibung"
                                        [rows]="4" [ngModelOptions]="{standalone: true}"></textarea>
                                </div>

                                <div class="input-group mb-3">
                                    <span class="input-group-text">Kategorie</span>
                                    <select class="form-select form-select-sm" [(ngModel)]="category"
                                        [ngModelOptions]="{standalone: true}">
                                        <option value="Zivilrecht">Zivilrecht</option>
                                        <option value="Strafrecht">Strafrecht</option>
                                        <option value="Öffentliches Recht">Öffentliches Recht</option>
                                    </select>
                                </div>

                                <!-- Tags Selection Section -->
                                <div class="mb-3">
                                    <label class="form-label fw-semibold">Tags</label>
                                    <div class="tags-selection">
                                        <small class="form-text text-muted mb-2 d-block">
                                            Wähle passende Rechtsgebiete für diesen Fall aus (max. 10):
                                        </small>

                                        <!-- Selected Tags Display -->
                                        <div *ngIf="tags.length > 0" class="selected-tags mb-3 p-2 bg-light rounded">
                                            <strong class="text-muted small">Ausgewählt ({{ tags.length }}/10):</strong>
                                            <div class="mt-2 d-flex flex-wrap gap-1">
                                                <span *ngFor="let tag of tags"
                                                    class="badge bg-primary position-relative">
                                                    {{ tag }}
                                                    <button type="button" class="btn-close btn-close-white ms-1"
                                                        style="font-size: 0.6rem; padding: 0; width: 12px; height: 12px;"
                                                        (click)="toggleTag(tag)"
                                                        [title]="'Tag ' + tag + ' entfernen'"></button>
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Available Tags -->
                                        <div *ngIf="category" class="available-tags">
                                            <div class="accordion" id="tagsAccordion">
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header" id="headingTags">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseTags"
                                                            aria-expanded="false" aria-controls="collapseTags">
                                                            Verfügbare Tags anzeigen ({{ getAvailableTags().length }})
                                                        </button>
                                                    </h2>
                                                    <div id="collapseTags" class="accordion-collapse collapse"
                                                        aria-labelledby="headingTags">
                                                        <div class="accordion-body"
                                                            style="max-height: 300px; overflow-y: auto;">
                                                            <div class="d-flex flex-wrap gap-1">
                                                                <button *ngFor="let tag of getAvailableTags()"
                                                                    type="button" class="btn btn-sm"
                                                                    [class.btn-secondary]="isTagSelected(tag)"
                                                                    [class.btn-outline-secondary]="!isTagSelected(tag)"
                                                                    [disabled]="!isTagSelected(tag) && tags.length >= 10"
                                                                    (click)="toggleTag(tag)">
                                                                    {{ tag }}
                                                                    <i *ngIf="isTagSelected(tag)"
                                                                        class="bi bi-check ms-1"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="!category" class="text-muted p-3 text-center bg-light rounded">
                                            <i class="bi bi-info-circle me-2"></i>
                                            Bitte wähle zuerst eine Kategorie aus.
                                        </div>
                                    </div>
                                </div>

                                <!-- Image Upload Section -->
                                <div class="mb-3">
                                    <label class="form-label">Bild (optional)</label>
                                    <div class="d-flex align-items-center gap-3">
                                        <!-- Image Preview -->
                                        <div class="image-preview-container">
                                            <img *ngIf="imagePreviewUrl; else noImagePreview" [src]="imagePreviewUrl"
                                                alt="Image Preview" class="image-preview">
                                            <ng-template #noImagePreview>
                                                <div class="image-placeholder">
                                                    <i class="bi bi-image"></i>
                                                </div>
                                            </ng-template>
                                        </div>

                                        <!-- Upload Controls -->
                                        <div class="flex-grow-1">
                                            <input type="file" id="imageInput" class="form-control" accept="image/*"
                                                (change)="onImageSelected($event)" style="display: none;">
                                            <div class="d-flex gap-2">
                                                <button type="button" class="btn btn-outline-primary btn-sm"
                                                    (click)="triggerFileInput()">
                                                    <i class="bi bi-upload"></i> Bild auswählen
                                                </button>
                                                <button type="button" class="btn btn-outline-danger btn-sm"
                                                    *ngIf="selectedImageFile" (click)="removeImage()">
                                                    <i class="bi bi-trash"></i> Entfernen
                                                </button>
                                            </div>
                                            <small class="form-text text-muted">
                                                Unterstützte Formate: JPG, PNG, GIF (max. 5MB)
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Sachverhalt</span>
                                    <textarea class="form-control" [(ngModel)]="situation" placeholder="Beschreibung"
                                        [rows]="4" [ngModelOptions]="{standalone: true}"></textarea>
                                </div>

                                <div class="input-group">
                                    <input type="file" class="form-control" id="inputGroupFile01"
                                        aria-describedby="inputGroupFileAddon01" aria-label="Upload" #fileInput>
                                    <button class="btn btn-outline-secondary" type="button" id="inputGroupFileAddon01"
                                        (click)="removeFile(fileInput)">Datei entfernen</button>
                                </div>


                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Musterloesung</span>
                                    <textarea class="form-control" [(ngModel)]="sampleSolution"
                                        placeholder="Beschreibung" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>

                                <div class="input-group">
                                    <input type="file" class="form-control" id="inputGroupFile02"
                                        aria-describedby="inputGroupFileAddon02" aria-label="Upload" #fileInput1>
                                    <button class="btn btn-outline-secondary" type="button" id="inputGroupFileAddon02"
                                        (click)="removeFile(fileInput1)">Datei entfernen</button>
                                </div>
                            </form>

                        </div>


                        <div *ngIf="processedMstrlsng" class="card-body scroll">
                            <div *ngFor="let chunk of processed_mstrlsg" class="row">
                                <div class="col-10">
                                    <p class="hoverable"
                                        [ngClass]="{'same-sw-index': hoveredFocusIndex +1 == chunk.schwrpnkt_index0 && hoveredFocusIndex > -1 }"
                                        (mouseenter)="onHoverChunkStart(chunk.index)"
                                        (mouseleave)="onHoverChunkEnd(chunk.index)">
                                        <b>Index: {{chunk.index}}</b>
                                        <br><b>{{chunk.heading}}</b>
                                        <i> {{chunk.text}}</i>
                                    </p>
                                </div>
                            </div>
                        </div>



                    </div>


                </div>
                <div class="col-sm-6 p-3">
                    <div class="d-flex control-container-page">
                        <div class="btn-group" dropdown>
                            <button id="button-basic" dropdownToggle type="button" class="btn btn-dark dropdown-toggle"
                                aria-controls="dropdown-basic"
                                [style]="{ 'border-bottom-right-radius': '0', 'border-bottom-left-radius': '0' }">
                                {{tabName}} <span class="caret"></span>
                            </button>
                            <ul *dropdownMenu id="dropdown-basic" class="dropdown-menu" role="menu"
                                aria-labelledby="button-basic">
                                <li><a class="dropdown-item" (click)="changeTab(0)">Rechtsfragen</a></li>
                                <li><a class="dropdown-item" (click)="changeTab(1)">Anspruchsgrundlagen</a></li>
                                <li><a class="dropdown-item" (click)="changeTab(2)">Vorausetzungen</a></li>
                                <li><a class="dropdown-item" (click)="changeTab(3)">Ergebnis</a></li>
                                <li><a class="dropdown-item" (click)="changeTab(4)">Votum</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="editor-input" *ngIf="this.tabNr == 0 " #scrollableDiv>
                        <div class="row mt-3">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form class="form-sm">
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Deviation Threshold</span>
                                                <input type="number" id="deviation_threshold"
                                                    class="form-control form-control-sm"
                                                    [(ngModel)]="deviationThreshold"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Index Threshold</span>
                                                <input type="number" id="index_threshold"
                                                    class="form-control form-control-sm" [(ngModel)]="indexThreshold"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Sim Threshold</span>
                                                <input type="number" id="sim_threshold"
                                                    class="form-control form-control-sm" [(ngModel)]="simThreshold"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Temperatur</span>
                                                <input type="number" id="temperature"
                                                    class="form-control form-control-sm" [(ngModel)]="temperature"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Max Output Tokens</span>
                                                <input type="number" id="max_output_tokens"
                                                    class="form-control form-control-sm" [(ngModel)]="maxOutputTokens"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group" *ngFor="let row of rows; let i = index">
                                                <div class="input-group mb-3">
                                                    <select class="form-select form-select-sm" [(ngModel)]="row.letter"
                                                        [ngModelOptions]="{standalone: true}">
                                                        <option *ngFor="let letter of getAvailableLetters(i)"
                                                            [value]="letter">{{ letter }}</option>
                                                    </select>
                                                    <input type="text" class="form-control form-control-sm"
                                                        [(ngModel)]="row.value" placeholder="Überschrift"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeRow(i)">-</button>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" (click)="addRow()">+
                                                Überschrift</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container d-flex justify-content-start align-items-start vh-100">
                            <form class="w-100">
                                <div class="form-group" *ngFor="let focus of focuses; let i = index"
                                    (mouseenter)="onHoverFocusStart(i)" (mouseleave)="onHoverFocusEnd(i)">
                                    <div class="input-group mb-3 hoverable-focus"
                                        (click)="onClickFocus(i,$event.currentTarget)">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt</div>
                                            <div>similarity:</div>
                                            <div *ngFor="let data of focus_data0[i];">
                                                <p *ngIf="hoveredChunkIndex == data.index">{{data.similarity}} </p>
                                            </div>

                                        </span>
                                        <textarea class="form-control" [(ngModel)]="focus.value"
                                            placeholder="Schwerpunkt" [rows]="4"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <button type="button" class="btn btn-sm btn-danger"
                                            (click)="removeFocus(i)">-</button>
                                    </div>

                                    <div class="input-group mb-3">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt Prompt</div>
                                        </span>
                                        <textarea class="form-control" placeholder="Schwerpunkt Prompt" [rows]="4"
                                            [(ngModel)]="schwerpunktPrompts[i].value"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-sm btn-primary" (click)="addFocus()">+
                                    Schwerpunkt</button>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Pre Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="prePrompt" placeholder="pre prompt"
                                        [rows]="4" [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Context Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="contextPrompt"
                                        placeholder="context prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                            </form>
                        </div>
                    </div>


                    <div class="editor-input" *ngIf="this.tabNr == 1 " #scrollableDiv>
                        <div class="row mt-3">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form class="form-sm">
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Deviation Threshold</span>
                                                <input type="number" id="deviation_threshold1"
                                                    class="form-control form-control-sm"
                                                    [(ngModel)]="deviationThreshold1"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Index Threshold</span>
                                                <input type="number" id="index_threshold1"
                                                    class="form-control form-control-sm" [(ngModel)]="indexThreshold1"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Sim Threshold</span>
                                                <input type="number" id="sim_threshold1"
                                                    class="form-control form-control-sm" [(ngModel)]="simThreshold1"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Temperatur</span>
                                                <input type="number" id="temperature1"
                                                    class="form-control form-control-sm" [(ngModel)]="temperature1"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Max Output Tokens</span>
                                                <input type="number" id="max_output_tokens1"
                                                    class="form-control form-control-sm" [(ngModel)]="maxOutputTokens1"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group" *ngFor="let row of rows1; let i = index">
                                                <div class="input-group mb-3">
                                                    <select class="form-select form-select-sm" [(ngModel)]="row.letter"
                                                        [ngModelOptions]="{standalone: true}">
                                                        <option *ngFor="let letter of getAvailableLetters(i)"
                                                            [value]="letter">{{ letter }}</option>
                                                    </select>
                                                    <input type="text" class="form-control form-control-sm"
                                                        [(ngModel)]="row.value" placeholder="Überschrift"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeRow1(i)">-</button>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" (click)="addRow1()">+
                                                Überschrift</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container d-flex justify-content-start align-items-start vh-100">
                            <form class="w-100">
                                <div class="form-group" *ngFor="let focus of focuses1; let i = index"
                                    (mouseenter)="onHoverFocusStart(i)" (mouseleave)="onHoverFocusEnd(i)">
                                    <div class="input-group mb-3 hoverable-focus"
                                        (click)="onClickFocus(i,$event.currentTarget)">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt</div>
                                            <div>similarity:</div>
                                            <div *ngFor="let data of focus_data1[i];">
                                                <p *ngIf="hoveredChunkIndex == data.index">{{data.similarity}} </p>
                                            </div>

                                        </span>
                                        <textarea class="form-control" [(ngModel)]="focus.value"
                                            placeholder="Schwerpunkt" [rows]="4"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <button type="button" class="btn btn-sm btn-danger"
                                            (click)="removeFocus1(i)">-</button>
                                    </div>

                                    <div class="input-group mb-3">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt Prompt</div>
                                        </span>
                                        <textarea class="form-control" [(ngModel)]="schwerpunktPrompts1[i].value"
                                            placeholder="Schwerpunkt Prompt" [rows]="4"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-sm btn-primary" (click)="addFocus1()">+
                                    Schwerpunkt</button>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Pre Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="prePrompt1" placeholder="pre prompt"
                                        [rows]="4" [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Context Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="contextPrompt1"
                                        placeholder="context prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="editor-input" *ngIf="this.tabNr == 2 " #scrollableDiv>
                        <div class="row mt-3">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form class="form-sm">
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Deviation Threshold</span>
                                                <input type="number" id="deviation_threshold2"
                                                    class="form-control form-control-sm"
                                                    [(ngModel)]="deviationThreshold2"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Index Threshold</span>
                                                <input type="number" id="index_threshold2"
                                                    class="form-control form-control-sm" [(ngModel)]="indexThreshold2"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Sim Threshold</span>
                                                <input type="number" id="sim_threshold2"
                                                    class="form-control form-control-sm" [(ngModel)]="simThreshold2"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Temperatur</span>
                                                <input type="number" id="temperature2"
                                                    class="form-control form-control-sm" [(ngModel)]="temperature2"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Max Output Tokens</span>
                                                <input type="number" id="max_output_tokens2"
                                                    class="form-control form-control-sm" [(ngModel)]="maxOutputTokens2"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group" *ngFor="let row of rows2; let i = index">
                                                <div class="input-group mb-3">
                                                    <select class="form-select form-select-sm" [(ngModel)]="row.letter"
                                                        [ngModelOptions]="{standalone: true}">
                                                        <option *ngFor="let letter of getAvailableLetters(i)"
                                                            [value]="letter">{{ letter }}</option>
                                                    </select>
                                                    <input type="text" class="form-control form-control-sm"
                                                        [(ngModel)]="row.value" placeholder="Überschrift"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeRow2(i)">-</button>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" (click)="addRow2()">+
                                                Überschrift</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container d-flex justify-content-start align-items-start vh-100">
                            <form class="w-100">
                                <div class="form-group" *ngFor="let focus of focuses2; let i = index"
                                    (mouseenter)="onHoverFocusStart(i)" (mouseleave)="onHoverFocusEnd(i)">
                                    <div class="input-group mb-3 hoverable-focus"
                                        (click)="onClickFocus(i,$event.currentTarget)">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt</div>
                                            <div>similarity:</div>
                                            <div *ngFor="let data of focus_data2[i];">
                                                <p *ngIf="hoveredChunkIndex == data.index">{{data.similarity}} </p>
                                            </div>

                                        </span>
                                        <textarea class="form-control" [(ngModel)]="focus.value"
                                            placeholder="Schwerpunkt" [rows]="4"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <button type="button" class="btn btn-sm btn-danger"
                                            (click)="removeFocus2(i)">-</button>
                                    </div>

                                    <div class="input-group mb-3">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt Prompt</div>
                                        </span>
                                        <textarea class="form-control" [(ngModel)]="schwerpunktPrompts2[i].value"
                                            placeholder="Schwerpunkt Prompt" [rows]="4"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-sm btn-primary" (click)="addFocus2()">+
                                    Schwerpunkt</button>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Pre Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="prePrompt2" placeholder="pre prompt"
                                        [rows]="4" [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Context Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="contextPrompt2"
                                        placeholder="context prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div class="editor-input" *ngIf="this.tabNr == 3" #scrollableDiv>
                        <div class="row mt-3">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form class="form-sm">
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Deviation Threshold</span>
                                                <input type="number" id="deviation_threshold3"
                                                    class="form-control form-control-sm"
                                                    [(ngModel)]="deviationThreshold3"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Index Threshold</span>
                                                <input type="number" id="index_threshold3"
                                                    class="form-control form-control-sm" [(ngModel)]="indexThreshold3"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Sim Threshold</span>
                                                <input type="number" id="sim_threshold3"
                                                    class="form-control form-control-sm" [(ngModel)]="simThreshold3"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Temperatur</span>
                                                <input type="number" id="temperature3"
                                                    class="form-control form-control-sm" [(ngModel)]="temperature3"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                            <div class="input-group mb-3">
                                                <span class="input-group-text">Max Output Tokens</span>
                                                <input type="number" id="max_output_tokens3"
                                                    class="form-control form-control-sm" [(ngModel)]="maxOutputTokens3"
                                                    [ngModelOptions]="{standalone: true}">
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="card local-card">
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group" *ngFor="let row of rows3; let i = index">
                                                <div class="input-group mb-3">
                                                    <select class="form-select form-select-sm" [(ngModel)]="row.letter"
                                                        [ngModelOptions]="{standalone: true}">
                                                        <option *ngFor="let letter of getAvailableLetters(i)"
                                                            [value]="letter">{{ letter }}</option>
                                                    </select>
                                                    <input type="text" class="form-control form-control-sm"
                                                        [(ngModel)]="row.value" placeholder="Überschrift"
                                                        [ngModelOptions]="{standalone: true}">
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                        (click)="removeRow3(i)">-</button>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn-sm btn-primary" (click)="addRow3()">+
                                                Überschrift</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container d-flex justify-content-start align-items-start vh-100">
                            <form class="w-100">
                                <div class="form-group" *ngFor="let focus of focuses3; let i = index"
                                    (mouseenter)="onHoverFocusStart(i)" (mouseleave)="onHoverFocusEnd(i)">
                                    <div class="input-group mb-3 hoverable-focus"
                                        (click)="onClickFocus(i,$event.currentTarget)">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt</div>
                                            <div>similarity:</div>
                                            <div *ngFor="let data of focus_data3[i];">
                                                <p *ngIf="hoveredChunkIndex == data.index">{{data.similarity}} </p>
                                            </div>

                                        </span>
                                        <textarea class="form-control" [(ngModel)]="focus.value"
                                            placeholder="Schwerpunkt" [rows]="4"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                        <button type="button" class="btn btn-sm btn-danger"
                                            (click)="removeFocus3(i)">-</button>
                                    </div>

                                    <div class="input-group mb-3">
                                        <span class="input-group-text" style="display: inline-block;">
                                            <div class="mb-2">{{i + 1}}.</div>
                                            <div>Schwerpunkt Prompt</div>
                                        </span>
                                        <textarea class="form-control" [(ngModel)]="schwerpunktPrompts3[i].value"
                                            placeholder="Schwerpunkt Prompt" [rows]="4"
                                            [ngModelOptions]="{standalone: true}"></textarea>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-sm btn-primary" (click)="addFocus3()">+
                                    Schwerpunkt</button>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Pre Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="prePrompt3" placeholder="pre prompt"
                                        [rows]="4" [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Context Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="contextPrompt3"
                                        placeholder="context prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                            </form>
                        </div>

                    </div>

                    <div class="editor-input" *ngIf="this.tabNr == 4" #scrollableDiv>
                        <div class="row mt-3">
                            <div class="col-sm-6 mb-3 mb-sm-0">
                                <div class="card local-card">
                                    <div class="card-body" style="min-height: 120px; overflow: hidden;">
                                        <form class="form-sm">
                                            <div class="input-group mb-3" style="visibility: hidden; height: 0;">
                                                <span class="input-group-text">Deviation Threshold</span>
                                                <input type="number" class="form-control form-control-sm" disabled>
                                            </div>
                                            <div class="input-group mb-3" style="visibility: hidden; height: 0;">
                                                <span class="input-group-text">Index Threshold</span>
                                                <input type="number" class="form-control form-control-sm" disabled>
                                            </div>
                                            <div class="input-group mb-3" style="visibility: hidden; height: 0;">
                                                <span class="input-group-text">Sim Threshold</span>
                                                <input type="number" class="form-control form-control-sm" disabled>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="card local-card">
                                    <div class="card-body" style="min-height: 120px; overflow: hidden;">
                                        <form>
                                            <div style="visibility: hidden; height: 0;">
                                                <div class="input-group mb-3">
                                                    <select class="form-select form-select-sm" disabled></select>
                                                    <input type="text" class="form-control form-control-sm" disabled>
                                                    <button type="button" class="btn btn-sm btn-danger"
                                                        disabled>-</button>
                                                </div>
                                            </div>
                                            <div style="visibility: hidden; height: 0;">
                                                <button type="button" class="btn btn-sm btn-primary" disabled>+
                                                    Überschrift</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="container d-flex justify-content-start align-items-start"
                            style="height: auto; overflow: hidden;">
                            <form class="w-100">
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Context Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="contextPrompt4"
                                        placeholder="context prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Erwartungshorizont Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="erwHorPrompt4"
                                        placeholder="Erwartungshorizont prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Temperatur</span>
                                            <input type="number" id="temperature_erwHor"
                                                class="form-control form-control-sm" [(ngModel)]="temperature_erwHor"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Max Output Tokens</span>
                                            <input type="number" id="max_output_tokens_erwHor"
                                                class="form-control form-control-sm"
                                                [(ngModel)]="max_output_tokens_erwHor"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                </div>

                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Inhalt Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="inhaltPrompt4"
                                        placeholder="inhalt prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Temperatur</span>
                                            <input type="number" id="temperature_inhalt"
                                                class="form-control form-control-sm" [(ngModel)]="temperature_inhalt"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Max Output Tokens</span>
                                            <input type="number" id="max_output_tokens_inhalt"
                                                class="form-control form-control-sm"
                                                [(ngModel)]="max_output_tokens_inhalt"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                </div>

                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Note Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="notePrompt4" placeholder="note prompt"
                                        [rows]="4" [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Temperatur</span>
                                            <input type="number" id="temperature_note"
                                                class="form-control form-control-sm" [(ngModel)]="temperature_note"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Max Output Tokens</span>
                                            <input type="number" id="max_output_tokens_note"
                                                class="form-control form-control-sm"
                                                [(ngModel)]="max_output_tokens_note"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="authService.isAdmin()" class="form-check mb-3">
                                    <input class="form-check-input" type="checkbox" id="selectGradingPrompt"
                                        [(ngModel)]="select_grading_prompt" [ngModelOptions]="{standalone: true}">
                                    <label class="form-check-label" for="selectGradingPrompt">
                                        Bewertung nach Teilpunkten
                                    </label>
                                </div>

                                <div class="input-group mb-3 mt-3">
                                    <span class="input-group-text">Ausblick Prompt</span>
                                    <textarea class="form-control" [(ngModel)]="ausblickPrompt4"
                                        placeholder="ausblick prompt" [rows]="4"
                                        [ngModelOptions]="{standalone: true}"></textarea>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Temperatur</span>
                                            <input type="number" id="temperature_ausblick"
                                                class="form-control form-control-sm" [(ngModel)]="temperature_ausblick"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="input-group mb-3">
                                            <span class="input-group-text">Max Output Tokens</span>
                                            <input type="number" id="max_output_tokens_ausblick"
                                                class="form-control form-control-sm"
                                                [(ngModel)]="max_output_tokens_ausblick"
                                                [ngModelOptions]="{standalone: true}">
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                    <button *ngIf="isCreated" type="button" class="btn btn-warning mt-3 mx-3"
                        (click)="downloadOverview()">Download Overview.csv</button>

                    <!-- Automatic processing indicator for non-admin users -->
                    <div *ngIf="isAutoProcessing && !authService.isAdmin()" class="alert alert-info mt-3 mb-3">
                        <i class="fa fa-spinner fa-spin me-2"></i>
                        Automatische Konfiguration läuft... Bitte warten, bis die Konfiguration verfügbar ist.
                    </div>

                    <div class="d-flex gap-2 mt-3" *ngIf="!isAutoProcessing || authService.isAdmin()">
                        <button *ngIf="isCreated" type="button" class="btn btn-success"
                            [disabled]="isAutoProcessing && !authService.isAdmin()" (click)="create(2, true, '-1')">
                            <span *ngIf="isAutoProcessing && !authService.isAdmin()">
                                <i class="fa fa-spinner fa-spin me-2"></i>Wird automatisch ausgeführt...
                            </span>
                            <span *ngIf="!isAutoProcessing || authService.isAdmin()">
                                Aktualisieren (Metadaten)
                            </span>
                        </button>

                        <button *ngIf="isCreated && authService.isAdmin()" type="button" class="btn btn-danger"
                            (click)="create(2, true, '-2')">
                            Full Rebuild (Alles)
                        </button>
                    </div>

                    <button *ngIf="!isCreated" type="button" class="btn btn-success mt-3"
                        (click)="create(1)">Hochladen</button>

                    <button *ngIf="CASE_ID" type="button" class="btn btn-outline-info mx-3 mt-3"
                        (click)="returnToCreateCase()">Return to create case</button>

                </div>

                <div class="justify-content-end text-end">

                </div>

            </div>
        </div>
    </div>
</ng-container>

<ng-template #nonAdminAutoProcessing>
    <div class="d-flex flex-column justify-content-center align-items-center"
        style="min-height: 60vh; text-align:center;">
        <div class="mb-4">
            <i class="fa fa-cog fa-spin fa-3x text-secondary"></i>
        </div>
        <h5 class="mb-3">Dein Fall wird automatisch vorbereitet…</h5>
        <p class="text-muted mb-0">Bitte warte einen Moment. Du wirst gleich automatisch weitergeleitet.</p>
    </div>
</ng-template>